import React, { FC } from 'react';
import Title from '../../../shared/tds/components/@atoms/title';

const NewRequestDescription: FC = () => {
  return (
    <React.Fragment>
      <Title>Volvo RMI Licensing Request Instructions</Title>
      <p>
        Volvo Cars provides the ability for automotive tool manufacturers and
        data vendors to purchase a license to bulk repair and maintenance
        information (RMI). Parts, Service and Diagnostic data is available to
        provide the ability for companies to develop IT solutions and scan tools
        for resale, using Volvo Car’s data.
      </p>
      <p>
        Our offer provides a 12-month* user license agreement. Data is made
        available and updated twice per year, (January and June). Below outlines
        our offers and pricing. Failure to renew on an annual basis will result
        in the termination of further data updates and the requirement to cease
        the use of the data.
      </p>
      <p>
        Delivery of the RMI to third Parties requires the purchase of the Access
        Package and at least one of the 3 content option packages. If you are
        creating a new account and you do not have a current RMI license with
        us, you must first obtain a Vendor Code, and there will also be a
        start-up fee included with the invoice.
      </p>
      <p>
        To request access, you are required to fill out all the information in
        the form below. A representative from Volvo Cars will review your
        request and may request additional information – which will come in the
        form of a post within this request. To view the status of your request,
        you can click on the link included in the email that you will receive,
        or you can go to your account in the drop-down menu in the upper right
        of the site.
      </p>
      <p>
        Once Volvo Cars approves the request, you will be required to agree to
        the RMI license terms, and Volvo will then request and process payment.
        The contract confirmation and term will be set from when the data is
        made available to you - which will not be until after the contract is
        signed, payment is made and processed, and you are set up with access.
        Please note that this may take up to a few weeks. Here is a description
        of the Content Option Packages:
      </p>
      <p>
        <strong>Parts Package</strong> is mainly concerned with all the parts
        and sections related information. Apart from that, the package also
        comprises of master data of car such as Base Data and Images, without
        any restriction of language, size or qualifier. The Parts data is
        delivered in a single package containing data for all languages.
      </p>
      <p>
        <strong>Service & Diagnostic (Sold Separately)</strong> are two
        important deliveries which are mainly dependent on and are comprised of
        many factors such as language, Image Rendition and allowed qualifier.
        Both the packages are prepared considering these three parameters. Both
        the packages contain almost the same datatype (filtered by factors then)
        but in addition to that, the Diagnostic Package contains D data, which
        is mainly built of Script/Software Product/ECU data. As parts data is
        managed separately through the Parts Package, parts data is not included
        in the Service & Diagnostic Packages.
      </p>
      <p>An Access Package and at least one content option required.</p>
      <table>
        <thead>
          <tr>
            <th>Access Package</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ borderBottom: 'none' }}>$34,275</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead>
          <tr>
            <th>Content Option Parts</th>
            <th>Content Option Service</th>
            <th>Content Option Diagnostics</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>+ $9,411</td>
            <td>+ $17,200</td>
            <td>+ $34,275</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <td style={{ borderTop: 'none' }}>
              There is a one time start-up fee for new customers: $11,425.
            </td>
          </tr>
        </tbody>
      </table>
      <p>Pricing does not include taxes, if applicable.</p>
      <p>
        Note that all DATA purchases are final. No refunds or credits will be
        processed.
      </p>
      <style jsx>{`
        table {
          width: 100%;
          border-collapse: collapse;
        }

        th,
        td {
          border: 1px solid #333;
          padding: 8px;
          text-align: center;
        }
      `}</style>
    </React.Fragment>
  );
};

export default NewRequestDescription;
